import { useEffect } from 'react';
import { XSAuthProvider, useXSAuthContext } from '@xinosolutions/xs-auth-react';
import { ProductProvider } from '../../context/ProductContext';
import { xsAuthBootstrapUrl, xsAuthClientId, xsAuthUrl, xsAccountUrl } from '../../config/config';
import { registerAuthSessionRefresher } from '../../lib/api';

function AuthenticatedApiProvider({ children }) {
  const { refreshSession } = useXSAuthContext();

  useEffect(() => registerAuthSessionRefresher(refreshSession), [refreshSession]);

  return children;
}

/** Same stack as xs-sites-web-app: XSAuthProvider → ProductSessionProvider. */
export default function AdminProviders({ children }) {
  return (
    <XSAuthProvider
      clientId={xsAuthClientId}
      authBaseUrl={xsAuthUrl}
      bootstrapUrl={xsAuthBootstrapUrl}
      accountUrl={xsAccountUrl}
    >
      <AuthenticatedApiProvider>
        <ProductProvider>{children}</ProductProvider>
      </AuthenticatedApiProvider>
    </XSAuthProvider>
  );
}
